import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// Ключ версіоновано (v2): історичні записи 'crm.locale' могли бути створені
// збереженням налаштувань без явного вибору мови, тому вони більше не читаються.
// Українська — за замовчуванням; російська — лише після власного вибору користувача.
const LOCALE_STORAGE_KEY = 'crm.locale.v2'

function savedLocale () {
  try {
    const saved = window.localStorage.getItem(LOCALE_STORAGE_KEY)
    if (saved === 'ru' || saved === 'uk') return saved
  } catch (e) {
    // сховище недоступне — використовуємо локаль за замовчуванням
  }
  return null
}

export default new VueI18n({
  locale: savedLocale() || 'uk',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ru',
  messages: loadLocaleMessages()
})
